export default __webpack_public_path__ + "static/media/desarrollo-web.b75260ff.svg";